import fetch from './fetch';
import { isNorway } from './country';

async function getEnhetsregisterInfo(orgNummer: string) {
  const linkToEnhetsregister =
    'https://data.brreg.no/enhetsregisteret/api/enheter';

  const response: any = await fetch.simpleGet({
    url: `${linkToEnhetsregister}/${orgNummer}`,
  });

  return response;
}

export async function fetchCompanyName(
  orgNumber: string,
  country: string
): Promise<{ companyNameFromFetch: string; status: string }> {
  const placeHolderOrgNumber = '000000000';
  const testAccountStartsWith: boolean = orgNumber.startsWith('00000');
  if (testAccountStartsWith) {
    if (orgNumber !== placeHolderOrgNumber) {
      return {
        companyNameFromFetch: `test company ${orgNumber.substring(5, 9)}`,
        status: '200',
      };
    } else if (orgNumber === placeHolderOrgNumber) {
      const placeHolderCompanyName = 'Placeholder Not For Real Person';
      return {
        companyNameFromFetch: placeHolderCompanyName,
        status: '200',
      };
    }
  }

  try {
    let response: Response;

    if (isNorway(country)) {
      response = await getEnhetsregisterInfo(orgNumber);
    } else {
      return { companyNameFromFetch: '', status: '200' };
    }

    if (response.status === 404) {
      return { companyNameFromFetch: '', status: String(response.status) };
    } else if (!response.ok) {
      const result = await response.json();
      return { companyNameFromFetch: '', status: String(result.status) };
    }
    const result = await response.json();

    return { companyNameFromFetch: result.navn, status: String(result.status) };
  } catch (e) {
    console.log('Error fetching enhetsregisteret', e);
    return { companyNameFromFetch: '', status: '500' };
  }
}

export async function fetchIsMvaRegistered(
  orgNummer: string
): Promise<boolean> {
  try {
    if (orgNummer.startsWith('00000')) return false;

    const response: Response = await getEnhetsregisterInfo(orgNummer);

    if (response.status === 404) {
      return false;
    }

    if (!response.ok) {
      throw new Error('Failed to fetch vat registration from brreg.');
    }
    const result = await response.json();

    return result.registrertIMvaregisteret;
  } catch (e) {
    console.log('Error fetching enhetsregisteret', e);
    throw e;
  }
}

export function getOrgNumber(courierCompanyNumber: number): string {
  if (courierCompanyNumber) {
    if (String(courierCompanyNumber).length > 0) {
      return String(courierCompanyNumber).replace(/\s/g, '');
    } else {
      return 'Not registered';
    }
  } else {
    return 'Not registered';
  }
}

export function getOrgNumberStringAsString(
  courierCompanyNumber: string
): string {
  if (courierCompanyNumber.length > 0) {
    const orgNumberWithoutSpaces = String(courierCompanyNumber).replace(
      /\s/g,
      ''
    );

    return orgNumberWithoutSpaces;
  } else {
    return '';
  }
}

export function getOrgNumberAsNumber(courierCompanyNumber: number): number {
  if (courierCompanyNumber) {
    if (String(courierCompanyNumber).length > 0) {
      return Number(String(courierCompanyNumber).replace(/\s/g, ''));
    } else {
      return 0;
    }
  } else {
    return 0;
  }
}
